import { Tag, Tooltip } from "antd";
import FlagAdminRecommended from "../FlagAdminRecommended/FlagAdminRecommended";
import React from "react";

// passedProgress (opsional): jumlah antrian selesai sejak antrian ini terlewat,
// ditampilkan di samping tanda "P" (hanya di layar admin, bukan layar pasien).
const QueueNumber = ({
  text = "-",
  isAdminRecommended,
  passedProgress,
  passedThreshold,
}) => {
  const showProgress =
    isAdminRecommended &&
    passedProgress !== undefined &&
    passedProgress !== null;

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <span>{text}</span>
      <FlagAdminRecommended isAdminRecommended={isAdminRecommended} />
      {showProgress && (
        <Tooltip
          title={
            passedThreshold
              ? `${passedProgress} antrian selesai sejak terlewat. Dibatalkan otomatis pada ${passedThreshold} antrian.`
              : `${passedProgress} antrian selesai sejak terlewat.`
          }
        >
          <Tag bordered={false} color="orange" style={{ marginRight: 0 }}>
            {passedThreshold
              ? `${passedProgress} / ${passedThreshold}`
              : passedProgress}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
};

export default QueueNumber;
